// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"jAb7d","socialButtonsContainer":"_2s9AM","shareButton":"_2ut7V"};